import { format } from 'date-fns/esm';
import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query'

import BookingModal from '../BookingModal/BookingModal';
import Appointoption from './Appointoption';
import Loading from '../../Home/Share/Loading/Loading';

const AvailableAppointment = ({ selectedDate }) => {
    // const [appointmentoption, setAppointmentoption] = useState([]);
    const [treatment, setTreatment] = useState(null);
    const date = format(selectedDate, 'PP');

    const { data: appointmentoption = [], refetch, isLoading } = useQuery({
        queryKey: ['appointmentoption', date],
        queryFn: () => fetch(`https://doctor-portal-server-theta.vercel.app/v2/appointmentOptions?date=${date}`)
            .then(res => res.json())
    });
    if (isLoading) {
        return <Loading></Loading>
    }



    return (
        <section className='my-8'>
            <p className='text-center text-secondary font-bold mt-6 '>Available Appointments on {format(selectedDate, 'PP')}</p>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-12'>
                {
                    appointmentoption.map(option => <Appointoption key={option._id} option={option}
                        setTreatment={setTreatment}
                    ></Appointoption>)
                }
            </div>
            {
                treatment &&
                <BookingModal treatment={treatment}
                    selectedDate={selectedDate}
                    refetch={refetch}
                    setTreatment={setTreatment}
                ></BookingModal>
            }
        </section>
    );
};

export default AvailableAppointment;